/**
 * Memara MCP host for OAuth redirects and MCP client URLs.
 * Set VITE_MCP_BASE_URL in env (e.g. https://mcp.local.memara.io for tunnel dev).
 */
export function getMcpBaseUrl(): string {
  const raw = import.meta.env.VITE_MCP_BASE_URL || 'https://mcp.memara.io';
  return raw.replace(/\/$/, '');
}

/** Streamable HTTP MCP URL (legacy shared OAuth connector). */
export function getMcpTransportUrl(): string {
  return `${getMcpBaseUrl()}/mcp`;
}

/** Per-integration OAuth connector URL for Claude (one connector per memory space). */
export function getMcpConnectorUrl(bindingId: string): string {
  return `${getMcpBaseUrl()}/c/${bindingId}/mcp`;
}
